import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/AxiosInstance";

// Group Member List Api
export const groupMemberListApi = async (data) => {
  const endPoint =
    `user/group-member/list` +
    "?" +
    new URLSearchParams({
      ...data,
      pagination: true,
      page: 1,
      limit: 1000,
    }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Update Group Member
export const updateGroupMemberApi = async (data) => {
  const endPoint = `user/group-member/join`;
  return await axios.put(endPoint, data, setJwtToken());
};

// Member Profile
export const memberProfileApi = async (data) => {
  const endPoint = `/user/account/view-profile?_user=${data}`;

  return await axios.get(endPoint, setJwtToken());
};

// Send Chat request
export const chatRequestApi = async (data) => {
  const endPoint = `/user/account/chat-request`;
  return await axios.post(endPoint, data, setJwtToken());
};
//---------get-Check-Live-Api-------------------
export const getCheckLiveApi = async (data) => {
  const endPoint = `user/home` + "?" + new URLSearchParams().toString();
  return await axios.get(endPoint, setJwtToken());
};